import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'
import { ui } from '../../../../utils/uiTokens'

interface Props {
    open: boolean
    handleClose: () => void
}

const ScoreScaleDialog: React.FC<Props> = ({ open, handleClose }) => {
    const { formatMessage } = useIntl()

    const rows = [
        { id: 'video', points: '+20', source: 'automatic', rule: '85%+' },
        { id: 'test', points: '0-20', source: 'automatic', rule: '%' },
        { id: 'conspect', points: '+5', source: 'mentorSets', rule: '' },
        { id: 'zachet', points: '0-20', source: 'mentorSets', rule: '' },
        { id: 'practice', points: '20 / 10 / 0', source: 'systemAndMentor', rule: '' },
    ]

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {formatMessage({ id: 'scoreScale' })}
                <IconButton onClick={handleClose}>
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {rows.map((row) => (
                    <Box
                        key={row.id}
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr auto auto',
                            gap: 2,
                            alignItems: 'center',
                            py: 1.5,
                            borderBottom: `1px solid ${ui.border}`,
                        }}
                    >
                        <Box sx={{ fontSize: '14px', color: ui.ink }}>
                            {formatMessage({ id: row.id })}
                            {row.rule && (
                                <Box component="span" sx={{ ml: 1, fontSize: '12px', color: ui.muted }}>
                                    {row.rule}
                                </Box>
                            )}
                        </Box>

                        <Box sx={{ fontSize: '14px', fontWeight: 600, color: ui.pink }}>{row.points}</Box>

                        <Box
                            sx={{
                                fontSize: '11.5px',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                color: ui.sub,
                                background: ui.track,
                                borderRadius: '100px',
                                px: 1.5,
                                py: 0.5,
                            }}
                        >
                            {formatMessage({ id: row.source })}
                        </Box>
                    </Box>
                ))}
            </DialogContent>
        </Dialog>
    )
}

export default ScoreScaleDialog
